import React from "react";
import PropTypes from "prop-types";

const CONTAINER_STYLE = {
  flex: "1 1 0",
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
};

const MESSAGE_STYLE = { color: "#9ca3af", marginBottom: 6 };

const LINK_STYLE = {
  color: "var(--primary-color)",
  textDecoration: "underline",
  cursor: "pointer",
};

// Empty-state centralizado dos painéis de conta (Ordens Abertas / Posições),
// com o link de login do roteador quando desconectado. Extraído de 2 cópias
// quase-verbatim (auditoria 2026-07-17, item 6b). BookByPricePanel tem impl
// própria (modal local) e fica de fora de propósito.
const PanelEmptyState = ({ message, isRouterConnected, dataEvoId }) => (
  <div style={CONTAINER_STYLE}>
    <div style={MESSAGE_STYLE}>{message}</div>
    {/* Show link to open router login when router appears offline */}
    {!isRouterConnected && (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          window.dispatchEvent(new CustomEvent("openRouterLogin"));
        }}
        style={LINK_STYLE}
        data-evo-id={dataEvoId}
      >
        Conecte-se ao roteador
      </a>
    )}
  </div>
);

PanelEmptyState.propTypes = {
  message: PropTypes.string.isRequired,
  isRouterConnected: PropTypes.bool,
  dataEvoId: PropTypes.string.isRequired,
};

export default PanelEmptyState;
